import React, { useState, useEffect } from "react";
import styles from "./TransactionModal.module.css";
import ScrollShadowBox from "../ScrollShadowBox/ScrollShadow.module";
import { persianDate } from "../../Utility/Utilities";
const TransactionModal = ({ isOpen, onClose, fetchTransactions }) => {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const loadTransactions = async () => {
        const data = await fetchTransactions();
        setTransactions(data);
      };
      loadTransactions();
    }
  }, [isOpen, fetchTransactions]);

  const formatAmount = (amount) => {
    const formatted = `${Math.abs(amount).toLocaleString("fa-IR")}`;
    return amount < 0 ? `-${formatted}` : `+${formatted}`;
  };

  if (!isOpen) return null;

  return (
    <div className={styles.custommodaloverlay} onClick={onClose}>
      <div
        className={styles.custommodalcontent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-history"></i>
          </div>
          <button className={styles.custommodalclose} onClick={() => onClose()}>
            ×
          </button>
        </div>
        <div className={styles.renewtitle}>تاریخچه و صورتحساب‌ها</div>
        <div className={styles.transactionlist}>
          <ScrollShadowBox>
            {transactions.map((transaction) => (
              <div key={transaction.id} className={styles.transactionitem}>
                <div>
                  <p className={styles.transactiontype}>{transaction.Reason}</p>
                  <p className={styles.transactiondate}>
                    {persianDate(transaction.DateTime)}
                  </p>
                </div>
                <div>
                  <p
                    className={`${
                      transaction.Amount > 0
                        ? styles.transactionamountpositive
                        : styles.transactionamountnegative
                    }`}
                  >
                    <span className={styles.leftDirection}>
                      {formatAmount(transaction.Amount)}
                    </span>
                    تومان
                  </p>
                  <p className={styles.transactionstatus}>
                    {transaction.status}
                  </p>
                </div>
              </div>
            ))}
          </ScrollShadowBox>
        </div>
        {/* <div className={styles.modalactions}>
          <button className={styles.gonext} onClick={onClose}>
            بستن
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default TransactionModal;
